import { Injectable, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ComponentType } from "@angular/cdk/portal";
import { Subscription } from "rxjs";
import { BreakpointObserver } from "@angular/cdk/layout";

@Injectable({ providedIn: "root" })
export class DialogService implements OnDestroy {
  breakpointObserverSubscription: Subscription;
  isMobile = false;

  constructor(
    public dialog: MatDialog,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserverSubscription = this.breakpointObserver
      .observe(["(max-width: 600px)"])
      .subscribe(result => {
        if (result.matches) {
          this.isMobile = true;
        }
      });
  }

  open(component: ComponentType<any>) {
    if (this.isMobile) {
      this.dialog.open(component, {
        width: "100vw",
        maxWidth: "100vw",
        height: "100vh"
      });
    } else {
      this.dialog.open(component);
    }
  }

  ngOnDestroy() {
    this.breakpointObserverSubscription.unsubscribe();
  }
}
